import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { AppRoutes } from './routes';
import { theme, GlobalStyles } from './styles';
import { SidebarProvider } from './context/SidebarContext';

const App: React.FC = () => {
  const isSidebarCollapsed = false;
  
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <SidebarProvider isSidebarCollapsed={isSidebarCollapsed}>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </SidebarProvider>
    </ThemeProvider>
  );
};

export default App;
